// Add your custom JS here.

(function () {
    "use strict";

    // Navbar scroll class
    window.addEventListener("scroll", function () {
        if (window.scrollY > 300) {
            document.querySelectorAll(".navbar-front").forEach(function (el) {
                el.classList.add("scrolled");
            });
        } else {
            document.querySelectorAll(".navbar-front").forEach(function (el) {
                el.classList.remove("scrolled");
            });
        }
    });

    // Po kliknięciu w link w nawigacji — ukryj rozwinięte menu
    document.querySelectorAll(".navbar-nav > li > a").forEach(function (link) {
        link.addEventListener("click", function () {
            const navbarCollapse = document.querySelector(".navbar-collapse");
            if (navbarCollapse.classList.contains("show")) {
                navbarCollapse.classList.remove("show"); // ukryj menu
            }
        });
    });

})();